import { Link } from "core/link"
import React from "react"

/**
 * CancellationPendingBanner displays when a subscription is scheduled to be cancelled.
 *
 * IF YOU UPDATE THIS FILE, YOU MUST ALSO UPDATE THE SERVER-SIDE RENDERED COMPONENT IN /app/views/layouts/_cancellation_pending.html.erb
 *
 * @param {string} cancelDate - The date the subscription is scheduled to be cancelled
 * @param {boolean} hasStripeSubscription - Whether the subscription is managed by Stripe
 * @param {string} billingSettingsPath - The path to the billing settings page
 */

export function CancellationPendingBanner({
  cancelDate,
  hasStripeSubscription,
  billingSettingsPath
}) {
  return (
    <div className="alert-no-hide alert-warning alert--banner alert--account-review">
      {hasStripeSubscription ? (
        <p>
          Your subscription is scheduled to be cancelled on{" "}
          <strong>{cancelDate}</strong>. Visit{" "}
          <Link
            href={billingSettingsPath}
            className="text-blue-500 hover:text-gray-700"
          >
            billing settings
          </Link>{" "}
          to reinstate your plan.
        </p>
      ) : (
        <p>
          Your subscription is scheduled to be cancelled on{" "}
          <strong>{cancelDate}</strong>.{" "}
          <Link
            href="mailto:help@kit.com"
            className="text-blue-500 hover:text-gray-700"
          >
            Contact support
          </Link>{" "}
          to reinstate your plan.
        </p>
      )}
    </div>
  )
}
